<template>
  <v-card
    tile
  >
    <v-img
      :src="cardImage"
    />
    <v-card-title>
      Prosenseガイダンスシリーズ
    </v-card-title>
    <v-card-subtitle>
      Prosenseを初めて利用される方向けのガイダンス動画
    </v-card-subtitle>
    <v-card-text>
      Prosenseを利用するにあたって、必要になるツールやソフトをセットアップしたり、利用に際しての注意点を動画で説明します<br/>動画を観て講師と一緒にステップバイステップでPCを操作しながら準備を進めることができます
    </v-card-text>
    <v-card-actions>
      <a href="/video-lessons/guidance/">
        <v-btn
          color="purple"
          text
        >
          無料で視聴する
        </v-btn>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
import Image from '@/assets/img/video-lessons/prosense-guidance-card.jpg'

export default {
  name: 'VProsenseGuidance',
  data() {
    return {
      cardImage: Image
    }
  }
}
</script>